<template>
  <b-card>
    <b-form @reset="resetFilter">
      <fieldset :disabled="loading">
        <b-form-group id="name-group" :label="$t('name')" label-for="name">
          <b-form-input size="sm" id="name" type="text" v-model="filter.name" v-on:keyup="onkeyup"/>
        </b-form-group>

        <b-form-group id="id-group" :label="$t('productIdTypes')" label-for="id">
          <b-form-input size="sm" id="id" type="text" v-model="filter.id" v-on:keyup="onkeyup" :autofocus="true"/>
        </b-form-group>

        <b-form-group id="site-group" :label="$t('site')" label-for="site">
          <b-form-select size="sm" id="site" :options="sites" v-model="filter.site" v-on:change="updateProducts">
            <template slot="first">
              <option :value="null">{{ $t('all') }}</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="productSource-group" :label="$t('productSource')" label-for="productSource">
          <b-form-select size="sm" id="productSource" :options="productSource" v-model="filter.source" v-on:change="updateProducts">
            <template slot="first">
              <option :value="null">{{ $t('all') }}</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="productForm-group" :label="$t('productForm')" label-for="productForm">
          <b-form-select size="sm" id="productForm" :options="productForm" v-model="filter.productForm" v-on:change="updateProducts">
            <template slot="first">
              <option :value="null">{{ $t('all') }}</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="productType-group" :label="$t('productType')" label-for="productType">
          <b-form-select size="sm" id="productType" :options="productTypes" v-model="filter.productType" v-on:change="updateProducts">
            <template slot="first">
              <option :value="null">{{ $t('all') }}</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="componentType-group" :label="$t('componentType')" label-for="componentType">
          <b-form-select size="sm" id="productType" :options="componentType" v-model="filter.componentType" v-on:change="updateProducts">
            <template slot="first">
              <option :value="null">{{ $t('all') }}</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="licenseType-group" :label="$t('licenseType')" label-for="licenseType">
          <b-form-select size="sm" id="licenseType" :options="licenseTypes" v-model="filter.licenseType" v-on:change="updateProducts">
            <template slot="first">
              <option :value="null">{{ $t('all') }}</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="valid-group" :label="$t('filter')">
          <b-form-checkbox size="sm" v-model="filter.includeBundledProducts" name="checkbox" switch inline v-on:change="updateProducts">
            {{ $t('includeBundledProducts') }}
          </b-form-checkbox>
        </b-form-group>

        <b-row>
          <b-col>
            <b-form-select size="sm" id="perPage" v-model="paging.perPage" :options="paging.perPageAlternatives"/>
          </b-col>
          <b-col>
            <b-button size="sm" class="float-right" v-on:click="resetFilter">{{ $t('reset') }}</b-button>
          </b-col>
        </b-row>

        <b-form-group>
          <pagination v-bind:pagination="paging"/>
        </b-form-group>

        <b-row>
          <b-col>
            <b-button type="button" block variant="primary" @click="openCreateLocalProductModal">{{ $t('createLocalProduct') }}</b-button>
            <create-local-product-modal ref="createLocalProductModal"/>
          </b-col>
        </b-row>

      </fieldset>
    </b-form>
  </b-card>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters, mapState } from 'vuex'
  import CreateLocalProductModal from './CreateLocalProductModal'

  export default {
    name: 'ProductFilter',
    extends: BaseComponent,
    components: {
      CreateLocalProductModal
    },

    computed: {
      ...mapGetters('products', ['filter', 'paging', 'loading']),
      ...mapState('products', { filter: state => state.filter })
    },
    methods: {
      onkeyup (event) {
        if (event.which === 13) {
          this.updateProducts()
        }
      },
      updateProducts () {
        this.$store.dispatch('products/getProducts')
      },
      resetFilter () {
        this.$store.dispatch('products/resetFilter')
        this.updateProducts()
      },
      openCreateLocalProductModal () {
        this.$store.dispatch('products/resetCreateLocalForm')
        this.$root.$emit('bv::show::modal', 'createLocalProductModal')
      }
    },
    watch: {
      'paging.perPage': function () {
        this.updateProducts()
      },
      'paging.currentPage': function () {
        this.updateProducts()
      }
    }
  }
</script>
